import { Checkbox, Input } from "antd";
import React from "react";
import CustomRadio from "../Radio/RadioSelector";
import "./Input.css";
const CustomInputOption = ({
  optionNumber,
  onSelect,
  value = "",
  placeholder,
  onChange,
  selected = false,
  isCorrect = false,
  isMultiple = false,
}) => {
  return (
    <div
      style={{
        height: "46px",

        border: "1px solid rgba(232, 232, 232, 1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "99%",
        borderRadius: "12px",
        paddingRight: "10px",
        cursor: "pointer",
      }}
      //   onClick={onSelect}
    >
      <div
        style={{
          width: "100%",
        }}
      >
        <Input
          onFocus={(e) => {
            e.target.style.border = "none";
            e.target.style.boxShadow = "none";
          }}
          className="custom-option-input"
          type="text"
          onClick={(e) => e.stopPropagation()}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          style={{
            border: "none",
            outline: "none",
            fontSize: "14px",
            backgroundColor: "transparent",
            width: "100%",
            height: "46px",
          }}
        ></Input>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "12vw",
          justifyContent: "end",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <span
          style={{
            color: selected
              ? "rgba(139, 139, 139, 1)"
              : "rgba(200, 200, 200, 1)",
            fontSize: "14px",
          }}
        >
          (Correct answer)
        </span>
        {!isMultiple ? (
          <div onClick={onSelect}>
            <CustomRadio checked={selected} />
          </div>
        ) : (
          <div onClick={onSelect}>
            <Checkbox checked={selected} className="custom-red-checkbox" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomInputOption;
